import { Component, Input, TemplateRef } from '@angular/core';
import { FrontendFieldAddon } from '../../models/frontend-field-addon.model';
import { FrontendField } from '../../netgen/FrontendField';

@Component({
    selector: 'app-sm-form-field-wrapper',
    templateUrl: './sm-form-field-wrapper.component.html',
    styleUrls: ['./sm-form-field-wrapper.component.scss'],
    standalone: false
})
export class SmFormFieldWrapperComponent {

    @Input()
    field: FrontendField = null;

    @Input()
    child: TemplateRef<any>;

    clickAddOn(addOn: FrontendFieldAddon, event: MouseEvent): void {
        if (addOn.onClick != null) {
            addOn.onClick(addOn, this.field, event);
        }
        else if (this.field.onAddOnClick != null) {
            this.field.onAddOnClick(addOn, this.field, event);
        }
    }
}
